// extracted by mini-css-extract-plugin
export default {"tooltip":"components-hotel-pricing-assistant-calendars-days-day-pricing-assistant-module__tooltip"};